/*
 * @Author: masonzhou
 * @Date: 2024-02-04 20:22:34
 * @LastEditTime: 2024-02-05 20:11:32
 * @FilePath: \yl-cjsph-tms-operation-front\src\utils\jsencrypt.js
 * @Description:
 */
import JSEncrypt from 'jsencrypt/bin/jsencrypt.min';

// 密钥对生成 http://web.chacuo.net/netrsakeypair

const publicKey =
  'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDnG1HbQwtMUQp2JzPhO+MpVx+xPKbixAxFw5caO4mTCRbxeVi9eAR6PpWF3BLKLqmOM+EdX2L3ha7FXUeyeky1mGErPJz9AOcg+J0tSNiVBIcvYMlSpX4zOJ3FRT/9EvkPQZ9nY5+5lyUMF6AhJoZe4IPSMo46InAxj1hqlKF07wIDAQAB';

const privateKey =
  'MIICdgIBADANBgkqhkiG9w0BAQEFAASCAmAwggJcAgEAAoGBAOcbUdtDC0xRCnYnM+E74ylXH7E8puLEDEXDlxo7iZMJFvF5WL14BHo+lYXcEsouqY4z4R1fYveFrsVdR7J6TLWYYSs8nP0A5yD4nS1I2JUEhy9gyVKlfjM4ncVFP/0S+Q9Bn2djn7mXJQwXoCEmhl7gg9IyjjoicDGPWGqUoXTvAgMBAAECgYBxuZXsae+TXIXjYqM7APdmDoN/+jK9gG/xnLAsroOioWRy653pjrfVWBrIRmXQrGmvmoP6qkfPOi+o26A+icRY4MqngrnLVfbnOOmlObn7hneZE25S3MxA9vJyF7Gt7YCYKoyXEWkhFgQA2a4du1KqmFHYEjYZdeY9STtOp2JBgQJBAP2/n1C819HNPbGzCCOJEidFaJYgWd2glwPF0w5xbs8LAMsNNr0sGjDR2Po2g+lmupm9EdQ2mICTsryiucjcGSECQQDpKESEJcLJYcPH0hN3A726ky0etlI3j2Qjix00gbQCT3VMcjP34MAIF6x9O3OZvafnfD4O4bkg82kwNufxkHwPAkBaaEmlBIOIlq2igH0n3BCBuXMX+hLKqgrkJzmZbcTjM7JmpiCYqfvy5PF/xKifIiDd4cVWbNVNClKmbvvumqzBAkEAtznLzkWWc4d+wZMXdNndybdLJ+2DYuIugbgbNV4QRhiHR5IfwNZAUpu4E5oa2GCwiDuc0TkVsQ1YRml/kNhIhQJAMxt8f1xfZDpOiSNbIR52gkKkMXiV6uBsfK5FkMetZYvxBH2G1DmrDigTGYWC9sUzGeLyVfT0RpFdgMgUCE3UMA==';

// 加密
export function encrypt(txt) {
  const encryptor = new JSEncrypt();
  encryptor.setPublicKey(publicKey); // 设置公钥
  return encryptor.encrypt(txt); // 对数据进行加密
}

// 解密
export function decrypt(txt) {
  const encryptor = new JSEncrypt();
  encryptor.setPrivateKey(privateKey); // 设置私钥
  return encryptor.decrypt(txt); // 对数据进行解密
}
